<!--suppress CssUnusedSymbol, JSUnusedAssignment -->
<script lang="ts">
    import {markWordLinkTranslation} from '$lib/utils/markWordLinkTranslation';
    import WordLink from '$lib/components/browse/WordCard/Sentence/WordLink.svelte';
    import AudioBrowseSentence from '$lib/components/browse/WordCard/Sentence/AudioBrowseSentence.svelte';
    import type {UserWordsMapStore} from '$lib/classes/stores/get-user-words-map';
    import {PunctMark, type Sentence} from '$lib/classes/data/sentence';
    import type {UserWord} from '$lib/classes/data/user-word';
    import type {CurrentWord} from '$lib/stores/currentWord';
    import {getContext} from 'svelte';
    import {keyUserActionProcessor} from '$lib/context-keys';
    import type {UserActionProcessor} from '$lib/classes/services/user-action-processor';

    export let currentWord: CurrentWord
    export let userWordsMap: UserWordsMapStore
    export let sentence: Sentence
    export let userWord: UserWord | undefined

    const userActionProcessor: UserActionProcessor = getContext(keyUserActionProcessor)

    $: currentSentenceId = userWord?.sentenceId
    $: currentSentence = currentSentenceId === sentence.id

    $: currentWordId = $currentWord!.id
    $: currentWordLink = sentence.wordLinks.find(wordLink => wordLink.id === currentWordId)
    $: currentWordLinkTranslation = currentWordLink!.t
    $: translation = markWordLinkTranslation(sentence.t!, currentWordLinkTranslation!)

    function handleSentenceClick() {
        userActionProcessor.saveSentence(currentWordId, sentence.id)
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events  a11y-no-static-element-interactions -->
<div class="sentence sentence-mobile"
     class:current-sentence={currentSentence}
     on:click={handleSentenceClick}
>
    <div class="sentence-de">
        {#each sentence.parts as part, index}
            {#if part instanceof PunctMark}
                <span class="sentence-mobile-pmark">{part.pmark}</span>
            {:else}
                <WordLink
                        userWordsMap={userWordsMap}
                        part={part}
                        currentWordId={currentWordId}
                />
            {/if}
        {/each}
    </div>
    <div class="sentence-translation">
        {@html translation}
    </div>
    <AudioBrowseSentence sentenceId={sentence.id}/>
</div>

<style>
    .sentence-mobile {
        position: relative;
        min-height: 76px;
        padding: .4rem .6rem;
        border: 2px solid transparent;
        border-radius: var(--border-radius);
        transition: var(--transition);
        user-select: none;
    }

    .sentence-mobile::before {
        position: absolute;
        content: '';
        top: 0;
        right: 0;
        width: 40px;
        height: 100%;
        transform: translateX(100%);
        background: var(--color-light);
        border-top-left-radius: var(--border-radius);
        border-bottom-left-radius: var(--border-radius);
        pointer-events: none;
    }

    .sentence-mobile.current-sentence::before {
        background: transparent;
    }

    .sentence-mobile::after {
        content: '•';
        line-height: 1.4rem;
        font-size: 1.4rem;
        position: absolute;
        display: grid;
        justify-items: center;
        align-items: center;
        bottom: 0;
        right: 0;
        transform: translate(calc(100% + 5px), -4px);
        width: 30px;
        height: 30px;
        border-radius: var(--border-radius);
        color: var(--color-audio-browse-sentence-mobile);
        transition: var(--transition);
    }

    .sentence-mobile.current-sentence::after {
        background: var(--color-accent);
        color: var(--text-on-color);
    }

    .sentence-mobile + :global(.sentence-mobile) {
        margin-top: .8rem;
    }

    .sentence-de span {
        line-height: 1;
        font-size: .82rem;
    }

    .sentence-translation {
        margin-top: .3rem;
        font-size: .9rem;
        color: var(--color-darker);
        font-style: italic;
    }

    .current-sentence {
        border-color: var(--color-accent);
        background: var(--color-lighter);
    }
</style>